import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function getActionsApi(
  eventId = '',
  orderBy = '',
  search = '',
  scheduleFilter = '',
  groupFilter = '',
  typeFilter = '',
) {
  try {
    const _ret = await axiosInstance({
      url: `${urlBaseAccreditation}/action/getList`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        eventId: parseInt(eventId),
        orderBy: orderBy,
        search: search,
        scheduleFilter: parseInt(scheduleFilter),
        groupFilter: parseInt(groupFilter),
        typeFilter: typeFilter,
        apiType: 'inteegra',
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;

  } catch (error) {
    console.log('Error getActionsApi', error);
    throw error;
  }
}
